import Strapi from '../../../types/strapi/strapi'
import Task from '../../../types/api/task'

export function mergeShipmentApprovals(
    tasksResponse: Strapi<Task>,
    approvalTasks: Task[]
): Strapi<Task> {
    const approvedByTaskId = new Map(
        approvalTasks.map(task => [task.documentId, task.shipment?.approved])
    )

    return {
        ...tasksResponse,
        data: tasksResponse.data.map(task =>
            task.shipment && approvedByTaskId.has(task.documentId)
                ? {
                      ...task,
                      shipment: {
                          ...task.shipment,
                          approved: approvedByTaskId.get(task.documentId),
                      },
                  }
                : task
        ),
    }
}
